import { Form, Modal } from "react-bootstrap";
import React, { useMemo, useState } from "react";
import styled from "styled-components";
import { CreateButton } from "./asideMenu";
import useRoutes from "../../utils/useRoutes";
import { Link, useLocation } from "react-router-dom";

const CustomModal = styled(Modal)`
  .modal-content {
    border-radius: 20px;
  }
`;

const ModalList = styled.ul`
  padding: 0;
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
`;

const ModalListItem = styled.li`
  list-style-type: none;
  width: 100%;
  padding: 0.5rem 1.5rem;
  background-color: #f4f5f7;
  border-radius: 10px;
  cursor: pointer;
  color: black;
  transition: all 0.3s ease;

  &:hover {
    background-color: var(--bs-primary);

    a {
      color: white;
    }
  }
`;

const ModalNavLinkStyled = styled(Link)`
  display: block;
  height: 100%;
  width: 100%;
  text-decoration: none;
  transition: color 0.3s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export default function MenuCreateModalButton() {
  const [showModal, setShowModal] = useState(false);
  const { modalRoutes } = useRoutes();

  const location = useLocation();

  const folderId = useMemo(() => {
    let searchParams = new URLSearchParams(location.search);
    return searchParams.get("folder_id");
  }, [location.search]);

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  function handleCustomAddLink(path) {
    if (path.startsWith("/addBooking") && folderId) {
      return `${path}?folder_id=${folderId}`;
    }

    return path;
  }

  return (
    <>
      <CreateButton onClick={handleOpenModal}>Créer</CreateButton>
      <CustomModal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/*<Form.Group controlId="search">
              <Form.Control type="text" placeholder="Recherche..." />
            </Form.Group>*/}
            <ModalList>
              {modalRoutes.map((route, index) => (
                <ModalListItem key={index}>
                  <ModalNavLinkStyled
                    to={handleCustomAddLink(route.path)}
                    onClick={handleCloseModal}
                  >
                    + {route.addLabel}
                  </ModalNavLinkStyled>
                </ModalListItem>
              ))}
            </ModalList>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          {/*<Button variant="secondary" onClick={handleCloseModal}>*/}
          {/*  Close*/}
          {/*</Button>*/}
        </Modal.Footer>
      </CustomModal>
    </>
  );
}
